import { Col, Input, Row, Select } from 'antd';

import { TasksQuery } from '@/core/domain/operational/Tasks/Tasks.types';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import ActiveExtraFilter from '@/components/_common/ExtraFilters/ActiveExtraFilter';
import { useIntl } from 'react-intl';

function TasksExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<TasksQuery>) {
  const intl = useIntl().formatMessage;

  return (
    <Row gutter={[12, 12]}>
      <Col span={24} md={12} lg={6}>
        <Select
          defaultValue={'false'}
          style={{ width: '100%' }}
          options={[
            {
              label: 'Por campo - Livre',
              value: 'false',
            },
            {
              label: 'Por campo - Especifico',
              value: 'true',
            },
          ]}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              isSpecificFilter: value === 'true',
            }))
          }
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <Input
          value={queryParams?.description}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, description: value }))
          }
          placeholder={intl({
            id: 'tasks.general.form.description',
          })}
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <ActiveExtraFilter
          value={queryParams?.active}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              active: value as unknown as boolean,
            }))
          }
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <Input
          value={queryParams?.temparioCode}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, temparioCode: value }))
          }
          placeholder={intl({
            id: 'tasks.general.form.temporaryCode',
          })}
        />
      </Col>
    </Row>
  );
}

export default TasksExtraFilters;
